module.exports = __webpack_public_path__ + "static/img/2023.4e4f33b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2023.png
// module id = vTG9
// module chunks = 1